// extracted by mini-css-extract-plugin
export var radioInputRow = "K_wv";
export var radioInputColumn = "K_ww";
export var inputOptionRow = "K_sq";
export var inputOptionColumn = "K_sr";